module.exports = __webpack_public_path__ + "img/case-logo-20.4ee6c504.png";